import { createServerAction, extract } from '@exonet/jsonapi-fetcher/lib/resources';

// DataObjects.
import { LocalSettingDataObject } from '@exonet/jsonapi-data-collections/lib';

// App constants.
import { constants } from 'app/client/store/reducers/app';

// Utilities.
import isUnlocked from 'app/client/utilities/isUnlocked';

// Contracts.
import { getLocalSettings, updateLocalSetting } from 'app/client/modules/Core/contracts';

const mapStateToProps = ({ app, api, user, otp }, { authorized }) => {
  const settings = authorized ? extract(getLocalSettings(), api).get() : false;

  return {
    language: app.language,
    settings,
    // Until the settings are in, a toggle could not be saved.
    settingsLoading: authorized && typeof settings.getByKey !== 'function',
    authenticated: user.id !== null,
    unlocked: user.id !== null && isUnlocked(otp),
    canSwitchCustomer: app.canSwitchCustomer,
    user,
  };
};

const mapDispatchToProps = (dispatch, { authorized }) => ({
  /**
   * Define actions to set the language and theme.
   *
   * @param {LocalSettingCollection|boolean} settings location settings or false if not authorized.
   */
  actions: (settings) => ({
    /**
     * Set the language to given payload.
     *
     * @param {string} payload The language to set.
     *
     * @return {Promise} The update result.
     */
    setLanguage: async (payload) => {
      const result = await dispatch({ type: constants.setLanguage, payload });

      // The settings load after an in-app login, so they can still be missing here.
      const setting = authorized ? settings?.getByKey?.('app.language').first() : undefined;

      if (setting) {
        const dataObject = new LocalSettingDataObject()
          .setId(setting.id())
          .attributes({ value: payload });

        // Dispatch the call to update a setting value.
        await dispatch(createServerAction(updateLocalSetting(dataObject)).patch());
      }

      return result;
    },
  }),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  ...dispatchProps,
  actions: dispatchProps.actions(stateProps.settings),
});

export default [mapStateToProps, mapDispatchToProps, mergeProps];
